import { SVGProps } from 'react';

const CircuitBoard = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M11 9h4a2 2 0 0 0 2-2V3m-6 6a2 2 0 1 1-4 0 2 2 0 0 1 4 0M7 21v-4a2 2 0 0 1 2-2h4m0 0a2 2 0 1 0 4 0 2 2 0 0 0-4 0M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2"
    />
  </svg>
);
export default CircuitBoard;
